import { ScopeSelectKeys } from 'legacy/lut/components/widgets/public/partner360/composedReport'
import {
  clearFilter,
  IComposedFilterForReport,
  selectFilterForReport,
  selectFilterIsEmpty,
  selectFilterWasChanged,
  selectScopeSelectValue,
} from 'legacy/lut/features/partner360/composedReport'
import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

interface IUseFilterActions {
  onFilter: (filterForReport: IComposedFilterForReport, notFetchPartnersInScope: boolean) => void
}

export const useFilterActions = ({ onFilter }: IUseFilterActions) => {
  const [showFirstFilterText, setShowFirstFilterText] = useState(true)
  const [wip, setWip] = useState(false)
  const filtersForReport = useSelector(selectFilterForReport)
  const scopeValue = useSelector(selectScopeSelectValue)
  const isFilterEmpty = useSelector(selectFilterIsEmpty)
  const isFilterWasChanged = useSelector(selectFilterWasChanged)
  const dispatch = useDispatch()

  const canClearFilter = useMemo(() => {
    return !isFilterEmpty
  }, [isFilterEmpty])

  const canApplyFilter = useMemo(() => {
    return !isFilterEmpty
  }, [isFilterEmpty])

  const filter = useCallback(async () => {
    setWip(true)
    await onFilter(filtersForReport, scopeValue === ScopeSelectKeys.ManualGlobal)
    setWip(false)
    setShowFirstFilterText(false)
  }, [filtersForReport, onFilter, scopeValue])

  const cleanFilter = useCallback(() => {
    dispatch(clearFilter())
  }, [dispatch])

  return {
    filter,
    cleanFilter,
    canClearFilter,
    showFirstFilterText,
    canApplyFilter,
    isFilterWasChanged,
    wip,
  }
}
